import React from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons/faLinkedin";
import { faGithub } from "@fortawesome/free-brands-svg-icons/faGithub";

const Footer = () =>{
    return (
        <>
        <footer className="footer">
        <div className="social">
            <NavLink to="https://www.linkedin.com/in/mohamednabeel1004/"><FontAwesomeIcon icon={faLinkedin} /></NavLink>
            <NavLink to="https://github.com/MohamedNabeel04" ><FontAwesomeIcon icon={faGithub}  /></NavLink>
        </div>
    <p className="copyright"> 
        &copy; Mohamed Nabeel | All Rights Reserved
        </p>
    </footer>
        </>
    )
}
export default Footer;